import apiClient from '../../../Services/ApiClient';

const isAvailableAddFamilyMember = async (userId: string) => {
	const { data } = await apiClient.get(`/patients/${userId}/family/available/`);
	return data;
};

export const isAvailableAddAdult = async (userId: string) => {
	const data = await isAvailableAddFamilyMember(userId);
	return data.adults;
};

export const isAvailableAddChildren = async (userId: string) => {
	const data = await isAvailableAddFamilyMember(userId);
	return data.children;
};
